"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeJsonSerialize = exports.transformRequestOptions = void 0;
const transformRequestOptions = (params) => {
    let options = "";
    for (const key in params) {
        if (typeof params[key] !== "object" && params[key]) {
            options += `${key}=${params[key]}&`;
        }
        else if (typeof params[key] === "object" &&
            params[key] &&
            params[key].length) {
            params[key].forEach((el) => {
                options += `${key}=${el}&`;
            });
        }
    }
    return options ? options.slice(0, -1) : options;
};
exports.transformRequestOptions = transformRequestOptions;
const safeJsonSerialize = (value) => {
    if (typeof value !== "string") {
        return JSON.stringify(value);
    }
    return value;
};
exports.safeJsonSerialize = safeJsonSerialize;
